import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';
import { CreditCardTypeService } from 'src/app/services/creditcardtype';
import { PaymentService } from 'src/app/services/payment.service';
import { PosSharedDataService } from 'src/app/services/pos -shared-data.service';
import { PosSettingsService } from 'src/app/services/pos-settings.service';
import { PosSalesService } from 'src/app/services/possalesservice';
import { customCurrencyPipe } from 'src/app/Shared/customCurrency.pipe';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { PaymentComponent } from 'src/app/Shared/payment/payment.component';
import { POSCustomerSearchComponent } from 'src/app/Shared/pos-customer-search/pos-customer-search.component';
import { ANGULAR_MODULES, Pos_COMPONENTS, SYNCFUSION_MODULES } from 'src/app/Shared/shared-imports';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import Swal from 'sweetalert2';
import Keyboard from 'simple-keyboard';
import { GiftCertificatesService } from 'src/app/services/gift-certificates.service';
import { DatePipe } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GeneralService } from 'src/app/services/general.service';
import printJS from 'print-js';
import { CurrencyInputDirective } from 'src/app/Shared/currency-input.directive';
import { UserService } from 'src/app/services/User.service';
import { MarketInfoService } from 'src/app/services/marketInfo.service';
import { PrinterSettingsService } from 'src/app/services/printer-settings.service';
import { CommonCalculatorService } from 'src/app/Shared/commonCalculators.service';
import { StripePaymentComponent } from '../../Shared/stripe-payment/stripe-payment.component';
import { EPaymentGateway } from '../../Shared/enum';

declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-pos-payment',
  standalone: true,
  imports: [SYNCFUSION_MODULES, ANGULAR_MODULES, SYNCFUSION_MODULES, Pos_COMPONENTS, POSCustomerSearchComponent, PaymentComponent,
    LoaderComponent, CurrencyInputDirective, customCurrencyPipe, StripePaymentComponent
  ],
  templateUrl: './pos-payment.html',
  styleUrl: './pos-payment.scss'
})
export class PosPayment implements OnInit, OnDestroy {
  secondLevelTaxName = "";
  applySalesTaxItemWise;
  netPrice;
  subTotal;
  quantity;
  discountAmount;
  salesTax;
  secondLvlTax;
  customerId;
  paymentForm: FormGroup;
  processPayment = false;
  totalPayment = "$0.00";
  activeControl = 'cashAmount';
  paymentGatewayCredentials;
  processCreditCardOnline;
  voidPayment = false;
  creditCardAmount = 0;
  forceCreditReturn;
  verifoneId = "";
  PosRequest = true;
  allCreditCards = [];
  creditCardList = [];
  keyedInTransaction = true;
  transactionType = "CREDITSALE";
  existingCustomer = false;
  customerSearch = true;
  customerData;
  newCustomer = false;
  enableOtherChargeinPos = false;
  posotherChargeName = "";
  saleType = '0';
  orderId;
  returnAmount = 0;
  ccAmountPaid = 0;
  giftCertificateList = [];
  filteredGiftCertificateList = [];
  gcSearchField = 'GiftCertificateNo';
  gcSearchValue = '';
  giftCertificateAmount = 0;
  travelerCheckTerm = "";
  chgPayModeInVoid = false;
  printThermalReceipt = false;
  thermalReceiptCopies = 1;
  posMerchantCopy = false;
  posMerchantCopies = 1;
  posCustomerCopy = false;
  posCustomerCopies = 1;
  refundAmount = 0;
  refundAsCashCardAmount = 0;
  @ViewChild('chequeNo') chequeNo: ElementRef;
  @ViewChild('traverlerCheckNo') traverlerCheckNo: ElementRef;
  voidPaymentDetails;
  @ViewChild('customerModal', { static: false }) customerModal: ElementRef;
  @ViewChild('modalGiftCertificate', { static: false }) modalGiftCertificate: ElementRef;
  @Output() closePaymentPage = new EventEmitter<any>();
  @Output() clearPaymentData = new EventEmitter<any>();
  @Input() paymentData;
  userName = "";
  marketName = "";
  public loaderIcon: Promise<boolean>;
  chargeCCProcessingFee = false;
  receiptUrl: SafeResourceUrl | null = null;
  gcreceiptUrl: SafeResourceUrl | null = null;
  loading = false;
  currentServerTime: Date;
  displayDate: string = '';
  displayTime: string = '';
  timerInterval: any;
  cardfessAddedToCardAmt = false;
  baseCardFees = 0;
  cardAmountFieldUpdate = false;
  uniqueSessionId = "";
  closeDisplay = true;
  closePrint = true;
  closeEmail = true;
  closeGCDisplay = true;
  closeGCprint = true;
  inputtedCCAmt = 0;
  selectedGCExpiryDate = '';

  isCashRoundingEnabled: boolean = false;
  makeTravelerNoOptional: boolean = false;
  isCashModeActive: boolean = false;
  effectiveCashAmount: number = 0;

  IsStrip = false;
  IsOpenEdgeExpress = false;

  constructor(private posSettingsService: PosSettingsService,
    private sharedData: PosSharedDataService,
    private customCurrency: customCurrencyPipe,
    private paymentService: PaymentService,
    private posSalesService: PosSalesService,
    private toastr: ToastrService,
    private creditCardTypeService: CreditCardTypeService,
    private fb: FormBuilder,
    private giftCertificatesService: GiftCertificatesService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
    private userService: UserService,
    private datePipe: DatePipe,
    private sanitizer: DomSanitizer,
    private marketInfo: MarketInfoService,
    private generalService: GeneralService,
    private printerService: PrinterSettingsService,
    private commonCalculatorService: CommonCalculatorService
  ) {
    this.paymentForm = this.fb.group({
      creditCardFees: ['$0.00'],
      ccFeesForVoidAndRet: ['$0.00'],
      roundedAmtVoidAndRet: ['$0.00'],
      balanceDue: ['$0.00'],
      changeDue: ['$0.00'],
      cashAmount: ['$0.00'],
      chequeAmount: ['$0.00'],
      creditCardAmount: ['$0.00'],
      salesTax: ['$0.00'],
      secondlvlTax: ['$0.00'],
      totalInvoiceAmount: ['$0.00'],
      otherCharges: ['$0.00'],
      chequeNo: [{ value: '', disabled: true }],
      totalPayment: ['$0.00'],
      creditCards: [{ value: '1', disabled: true }],
      travelerCheckAmt: ['$0.00'],
      traverlerCheckNo: [{ value: '', disabled: true }],
      appliedGCNo: [''],
      appliedGCAmount: ['$0.00'],
      printReceipt: [false],
      displayReceipt: [false],
      refundAsCash: [false],
      emailReceipt: [false],
      emailAddress: [{ value: '', disabled: true }, [Validators.email, Validators.maxLength(75)]],
      keyedInTransaction: [{ value: false, disabled: true }],
      roundingDifference: ['$0.00'],
      printGC : [false],
      displayGC : [false]
    })

    this.paymentForm.get('cashAmount').valueChanges.subscribe(() => this.calculateBalance());
    this.paymentForm.get('chequeAmount').valueChanges.subscribe(() => this.calculateBalance());
    //this.paymentForm.get('creditCardAmount').valueChanges.subscribe(() => this.calculateConvenienceFee());
    this.paymentForm.get('travelerCheckAmt').valueChanges.subscribe(() => this.calculateBalance());
    this.paymentForm.get('otherCharges').valueChanges.subscribe(() => this.calculateBalance());
    this.paymentForm.get('appliedGCAmount').valueChanges.subscribe(() => this.calculateBalance());
    this.paymentForm.get('refundAsCash')?.valueChanges.subscribe((checked: boolean) => {
      if (this.saleType === '7' && this.voidPaymentDetails) {
        this.distributeReturnAmount(this.voidPaymentDetails);
      } else if (this.saleType === '8') {
        this.applyRefundAsCashToVoid(!!checked);
      } else {
        this.calculateBalance();
      }
    });

    this.paymentForm.get('emailReceipt')?.valueChanges.subscribe(isChecked => {
      const emailCtrl = this.paymentForm.get('emailAddress');

      if (isChecked) {
        emailCtrl?.enable({ emitEvent: false });
        emailCtrl?.setValidators([
          Validators.required,
          Validators.email,
          Validators.maxLength(75)
        ]);
      } else {
        emailCtrl?.clearValidators();
        emailCtrl?.disable({ emitEvent: false });
        emailCtrl?.setValue('');
      }
      emailCtrl?.updateValueAndValidity();
    });

    this.paymentForm.get('creditCardAmount')?.valueChanges.subscribe(val => {
      if (this.saleType === '8' && this.ccAmountPaid > 0) {
        const amt = this.getActualAmountFromInp(val);
        if (amt > this.ccAmountPaid) {
          this.paymentForm.patchValue({
            creditCardAmount: this.customCurrency.transform(String(this.ccAmountPaid))
          }, { emitEvent: false });
        }
      }
    });
  }

  value: string = "";
  keyboard!: Keyboard;

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (['F2', 'F3', 'F4', 'F5'].includes(event.key)) {
      event.preventDefault();

      if (event.key === 'F2' && this.isCashRoundingEnabled) {
        this.activateCashRounding();
      }
      if (this.saleType != '8' && this.saleType != '7') {
        const zeroValue = this.customCurrency.transform("0");

        ['cashAmount', 'chequeAmount', 'creditCardAmount', 'travelerCheckAmt','appliedGCAmount']
          .forEach(field => {
            this.paymentForm.get(field)?.setValue(zeroValue, { emitEvent: false });
            this.inputtedCCAmt = 0; 
          });

        this.paymentForm.get('appliedGCNo')?.setValue("", { emitEvent: false }); 
        this.creditCardAmount = 0;

        const targetField =
          event.key === 'F2' ? 'cashAmount' :
            event.key === 'F3' ? 'chequeAmount' :
            event.key === 'F5' ? 'travelerCheckAmt' :
              'creditCardAmount';

        let targetAmount = "0";
        //targetAmount = this.netPrice;

        if (this.saleType !== '5') {
          targetAmount = String(this.getActualAmountFromInp(this.netPrice) + this.getActualAmountFromInp(this.paymentForm.get('otherCharges').value));
        } else if (this.paymentData?.InvoiceNo && !this.paymentData.IsPendingSale) {
          var paidInstCnt = this.paymentData?.LayawayData?.PaidInstallmentCount;
          if (paidInstCnt >= this.paymentData?.LayawayData?.InstallmentDetails?.length) {
            paidInstCnt = 0;
          }
          targetAmount = String(this.paymentData?.LayawayData?.InstallmentDetails?.[paidInstCnt]?.InstallmentAmount ?? "0");
          this.customCurrency.transform(targetAmount);
        } else {
          targetAmount = String(this.paymentData?.LayawayData?.DownPayAmount ?? 0);
          this.customCurrency.transform(targetAmount);
        }
        if (this.saleType == '5') {
          var finalTargetAmount = this.getActualAmountFromInp(targetAmount || 0);
        } else {
          var finalTargetAmount = this.getActualAmountFromInp(targetAmount || 0);
        }

        //ROUNDING ONLY FOR F2 (CASH) if cash rounding is enabled
        if (targetField === 'cashAmount' && this.isCashRoundingEnabled) {
          this.isCashModeActive = true;
          finalTargetAmount = this.applyCashRoundingIfEnabled(finalTargetAmount);
        }
        else {
          this.isCashModeActive = false;
          this.paymentForm.get('roundingDifference')?.setValue(zeroValue);
        }

        targetAmount = this.customCurrency.transform(finalTargetAmount.toString());

        this.paymentForm.get(targetField)?.setValue(targetAmount);
        this.inputtedCCAmt = 0;
        if (targetField == 'creditCardAmount') {
          this.inputtedCCAmt = finalTargetAmount;
          this.calculateConvenienceFee();
        }else{
          this.calculateBalance();
        }

      }
    }
  }

  ngOnInit(): void {
    this.userName = this.userService.getLoggedInUserName();
    this.getMarketName();
    this.loadServerTime();
    const tabId = sessionStorage.getItem('tabId');
    const sessionKey = `UniqueSessionId-${tabId}`;
    this.uniqueSessionId = localStorage.getItem(sessionKey);
    this.saleType = this.paymentData.SalesType == 'gc' ? '1' : this.paymentData.SalesType;
    var netPrice = "$0.00";
    if (this.saleType == '7' || this.saleType == '8')
      netPrice = this.customCurrency.transform((this.getActualAmountFromInp(this.paymentData.NetPrice) + this.getActualAmountFromInp(this.paymentData.OtherCharge)).toString());
    else
      netPrice = this.customCurrency.transform((this.getActualAmountFromInp(this.paymentData.NetPrice)).toString());
    // this.netPrice = this.paymentData.NetPrice;
    this.netPrice = netPrice;
    this.subTotal = this.paymentData.NetPrice;
    this.quantity = this.paymentData.Quantity;
    this.discountAmount = this.paymentData.DiscountAmount;
    this.salesTax = this.paymentData.SalesTax;
    this.secondLvlTax = this.paymentData.SecondLvlTax;
    this.customerId = this.paymentData.CustomerId;
    this.returnAmount = this.paymentData.ReturnAmount ?? 0;
    if (this.customerId) {
      // A default/placeholder customer is still loaded, but Update stays disabled until a real customer is selected
      this.getCustomerInfo(this.customerId, this.paymentData.CustomerSelected !== false);
    }
    this.paymentForm.patchValue({
      //otherCharges: this.paymentData.IsPendingSale ? "$.0.00" : this.paymentData.OtherCharge,
      balanceDue: this.netPrice,
      salesTax: this.salesTax,
      secondlvlTax: this.secondLvlTax
    });

    this.getPosSettings();
    this.getAllCreditCardsByMarket();
    this.getCCCredentials();
    this.getGiftCertificates();
    this.getCreditCardFeeSettings();
    this.getPOSPrinterSettings();
    document.body.style.overflow = 'scroll';
  }

  disableOtherCharge() {
    if (this.saleType == '7' || this.saleType == '8' || this.saleType == '5') {
      return true;
    }
  }

  getPOSPrinterSettings() {
    this.loaderIcon = Promise.resolve(true);
    this.printerService.getPOSPrinterSettings().pipe(take(1)).subscribe((res: any) => {
      if (res) {
        this.paymentForm.get('displayReceipt').setValue(res.PosreceiptDefaultDisplayChecked);
        this.paymentForm.get('printReceipt').setValue(res.PosreceiptDefaultPrintChecked);
        this.paymentForm.get('emailReceipt').setValue(res.PosreceiptDefaultEmailChecked);
        switch (this.saleType) {
          case '1':
            this.printThermalReceipt = res.RetailThermal;
            this.thermalReceiptCopies = res.RetailCopies;
            break;
          case '2':
            this.printThermalReceipt = res.WholesaleThermal;
            this.thermalReceiptCopies = res.WholesaleCopies;
            break;
          case '3':
            this.printThermalReceipt = res.OnlineSaleThermal;
            this.thermalReceiptCopies = res.OnlineSaleCopies;
            break;
          case '5':
            if (this.paymentData?.LayawayData?.LayawayPayType == "LAYDNPAYT") {
              this.printThermalReceipt = res.LayawayDownPaymentThermal;
              this.thermalReceiptCopies = res.LayawayDownPaymentCopies;
              break;
            }
            else if (this.paymentData?.LayawayData?.LayawayPayType == "LAYINSTLMT") {
              this.printThermalReceipt = res.LayawayInstallmentThermal;
              this.thermalReceiptCopies = res.LayawayInstallmentCopies;
              break;
            }
          case '6':
            this.printThermalReceipt = res.PendingSaleThermal;
            this.thermalReceiptCopies = res.PendingSaleCopies;
            break;
          case '7':
            this.printThermalReceipt = res.ReturnSaleThermal;
            this.thermalReceiptCopies = res.ReturnSaleCopies;
            break;
          case '8':
            this.printThermalReceipt = res.VoidSaleThermal;
            this.thermalReceiptCopies = res.VoidSaleCopies;
            break;
          case 'GC':
            this.printThermalReceipt = res.GcThermal;
            this.thermalReceiptCopies = res.GcCopies;
            break;
        }

        this.posMerchantCopy = res.PosMerchantCopy;
        this.posMerchantCopies = res.PosMerchantCopies;
        this.posCustomerCopy = res.PosCustomerCopy;
        this.posCustomerCopies = res.PosCustomerCopies;

      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
  }

  numberOnly(event): boolean {
    return this.commonCalculatorService.numberOnly(event);
  }

  numberOnlyWithNegative(event): boolean {
    return this.commonCalculatorService.numberOnlyWithNegative(event);
  }

  getMarketName(): void {
    this.marketInfo.getMarketName().pipe(take(1)).subscribe({
      next: (res) => {
        this.marketName = res;
      }
    })
  }

  ngAfterViewInit() {
    this.keyboard = new Keyboard({
      onChange: input => this.onChange(input),
      onKeyPress: button => this.onKeyPress(button)
    });
  }

  loadServerTime(): void {
    this.generalService.GetMarketCurrentTime().subscribe({
      next: (res: string) => {
        // Convert API response to Date
        this.currentServerTime = new Date(res);

        // Start live updating
        this.startLiveClock();
      },
      error: (err) => {
        console.error('Error fetching market time', err);
      }
    });
  }

  startLiveClock(): void {
    // Clear any previous interval
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.timerInterval = setInterval(() => {
      // Increment time by 1 second
      this.currentServerTime = new Date(this.currentServerTime.getTime() + 1000);

      // Format date
      const optionsDate: Intl.DateTimeFormatOptions = { weekday: 'short', month: 'long', day: 'numeric', year: 'numeric' };
      this.displayDate = this.currentServerTime.toLocaleDateString('en-US', optionsDate);

      // Format time
      const optionsTime: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: true };
      this.displayTime = this.currentServerTime.toLocaleTimeString('en-US', optionsTime);
    }, 1000);
  }

  onChange = (input: string) => {
    this.value = input;
  };

  onKeyPress = (button: string) => {
    if (button === "{shift}" || button === "{lock}") {
      this.handleShift();
    }
  };

  handleShift() {
    let currentLayout = this.keyboard.options.layoutName;
    let shiftToggle = currentLayout === "default" ? "shift" : "default";
    this.keyboard.setOptions({
      layoutName: shiftToggle
    });
  }

  getGiftCertificates() {
    var currentDate = this.datePipe.transform(new Date(), "MM/dd/yyyy");
    this.giftCertificatesService.getGiftCertificates(currentDate, 'Active')
      .pipe(take(1)).subscribe(res => {
        if (res) {
          // Filter out future gift certificates, then sort by StartDate (oldest first).
          const gcRecords = res.filter(e => {
            if (!e.StartDate) return false;
            const [month, day, year] = e.StartDate.split('/').map(Number);
            const startDate = new Date(year, month - 1, day); // month is 0-indexed
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return startDate <= today;
          }).sort((a, b) => {
            const [aMonth, aDay, aYear] = a.StartDate.split('/').map(Number);
            const [bMonth, bDay, bYear] = b.StartDate.split('/').map(Number);
            const aDate = new Date(aYear, aMonth - 1, aDay).getTime();
            const bDate = new Date(bYear, bMonth - 1, bDay).getTime();
            return aDate - bDate;
          });
          this.giftCertificateList = gcRecords.map(e => ({
            ...e, // keep existing properties if needed
            ItemDescription: "Gift Certificate",
            Balance: this.customCurrency.transform(e.Balance)
          }));
          this.filteredGiftCertificateList = [...this.giftCertificateList];
        }
      })
  }

  enteredCCAmount() {
    this.inputtedCCAmt = this.paymentForm.get('creditCardAmount').value;
  }

  getCreditCardFeeSettings() {
    this.creditCardTypeService.getCreditCardFeeSettings()
      .pipe(take(1)).subscribe(res => {
        if (res) {
          this.chargeCCProcessingFee = res.ChargeCCProcessingFee;
        }
      })
  }

  getInvoicePaymentDetails() {
    this.posSalesService.getInvoicePaymentDetails(this.paymentData.InvoiceNo)
      .pipe(take(1))
      .subscribe(res => {

        this.voidPaymentDetails = res;
        this.verifoneId = res.VerifoneId;
        this.orderId = res.OrderID;

        var cash = (res?.CashAmountPaid ?? 0) + (res?.RoundingAmount ?? 0);
        var gcAmount = res?.GiftCertificateAmount ?? 0;
        if (this.saleType === '7') {
          cash = cash + gcAmount;
          gcAmount = 0;
        }
        const cheque = res?.CheckAmountPaid ?? 0;
        const cc = res?.CCAmountPaid ?? 0;
        const traveler = res?.TravelerCheckAmountPaid ?? 0;
        this.ccAmountPaid = cc;
        const allowChange = this.chgPayModeInVoid === true;

        this.netPrice = this.customCurrency.transform(this.getActualAmountFromInp(this.netPrice) + (res.CCCharge) + (res?.RoundingAmount ?? 0));
        // Patch initial values
        this.paymentForm.patchValue({
          balanceDue: this.netPrice,
          totalInvoiceAmount: this.netPrice,
          cashAmount: this.customCurrency.transform(cash),
          chequeAmount: this.customCurrency.transform(cheque),
          chequeNo: res?.CheckNo,
          creditCardAmount: this.customCurrency.transform(cc),
          travelerCheckAmt: this.customCurrency.transform(traveler),
          traverlerCheckNo: res?.TravelerCheckNo,
          ccFeesForVoidAndRet: this.customCurrency.transform(res.CCCharge),
          roundedAmtVoidAndRet: this.customCurrency.transform(res?.RoundingAmount ?? 0),
          creditCards: res?.CardTypeId,
          appliedGCNo: this.saleType === '8' && gcAmount > 0 ? res?.GiftCertificateNo : "",
          appliedGCAmount : this.saleType === '8' && gcAmount > 0 ? this.customCurrency.transform(gcAmount) : this.customCurrency.transform("0")
        });

        if (this.saleType === '8' && this.chgPayModeInVoid === true) {
          this.validateMax('creditCardAmount', cc);
          this.validateMax('chequeAmount', cheque);
          this.validateMax('travelerCheckAmt', traveler);
        }

        // Reset control states
        ['cashAmount', 'chequeAmount', 'creditCardAmount', 'travelerCheckAmt', 'chequeNo', 'traverlerCheckNo', 'appliedGCAmount', 'appliedGCNo']
          .forEach(c => this.setControlState(c, allowChange));

        if (this.saleType === '8') {

          // Disable all first
          ['cashAmount', 'chequeAmount', 'creditCardAmount', 'travelerCheckAmt', 'appliedGCAmount', 'appliedGCNo']
            .forEach(c => this.setControlState(c, false));

          if (this.isCashRoundingEnabled && cash > 0 && cheque == 0 && traveler == 0 && cc == 0) {
            this.isCashModeActive = true;
          }
          setTimeout(() => { this.calculateBalance() })
        }

        /* ---------------- RETURN LOGIC (SaleType = 7) ---------------- */
        if (this.saleType === '7') {

          // Credit card always disabled for return
          this.setControlState('creditCardAmount', false);

          this.distributeReturnAmount(res);
        }
      });
  }

  validateMax(controlName: string, maxAmount: number) {
    this.paymentForm.get(controlName)?.valueChanges.subscribe(val => {
      const amt = this.getActualAmountFromInp(val);
      if (amt > maxAmount) {
        this.paymentForm.patchValue({
          [controlName]: this.customCurrency.transform(String(maxAmount))
        }, { emitEvent: false });
      }
    });
  }

  private distributeReturnAmount(res: any) {

    const totalPaid =
      ((res?.CashAmountPaid ?? 0) +
        (res?.CheckAmountPaid ?? 0) +
        (res?.CCAmountPaid ?? 0) +
        (res?.GiftCertificateAmount ?? 0) +
        (res?.TravelerCheckAmountPaid ?? 0)) -
      (res?.CCCharge ?? 0);

    var ccAmountPaid = (res?.CCAmountPaid ?? 0) - (res?.CCCharge ?? 0);
    if (totalPaid <= 0) return;

    const returnAmount = this.getActualAmountFromInp(this.returnAmount);
    const proportion = returnAmount / totalPaid;
    var cashPaid = (res?.CashAmountPaid ?? 0) + (res?.GiftCertificateAmount ?? 0);
    let cash = +(cashPaid * proportion).toFixed(2);
    let cheque = +(res?.CheckAmountPaid * proportion).toFixed(2);
    let cc = +(ccAmountPaid * proportion).toFixed(2);
    let traveler = +(res?.TravelerCheckAmountPaid * proportion).toFixed(2);

    const diff = +(returnAmount - (cash + cheque + cc + traveler)).toFixed(2);

    if (diff !== 0) {
      if (traveler > 0) traveler += diff;
      else if (cc > 0) cc += diff;
      else if (cheque > 0) cheque += diff;
      else cash += diff;
    }

    let finalCashValue = cash + cheque + traveler; //for return amount

    const refundAsCash = !!this.paymentForm.get('refundAsCash')?.value;
    if (refundAsCash) {
      finalCashValue = Number((finalCashValue + cc).toFixed(2));
      cc = 0;
    }

    let returnRoundingDiff = 0;
    // apply rounding only when enabled and only cash payment
    if (this.isCashRoundingEnabled && finalCashValue > 0) {
      const roundedCashValue = this.roundToNearestNickel(finalCashValue);
      returnRoundingDiff = Number((roundedCashValue - finalCashValue).toFixed(2));
      finalCashValue = roundedCashValue;
    }

    this.refundAmount = cc;
    this.paymentForm.patchValue({
      cashAmount: this.customCurrency.transform(String(finalCashValue)),
      chequeAmount: this.customCurrency.transform(String(0)),
      creditCardAmount: this.customCurrency.transform(String(cc)),
      travelerCheckAmt: this.customCurrency.transform(String(0)),
      chequeNo: "",
      traverlerCheckNo: "",
      roundingDifference: this.customCurrency.transform(returnRoundingDiff.toFixed(2).toString())
    });

    if (this.isCashRoundingEnabled && finalCashValue > 0) {
      this.isCashModeActive = true;
    }
    setTimeout(() => { this.calculateBalance() })
  }

  private applyRefundAsCashToVoid(checked: boolean) {
    const cash = this.getActualAmountFromInp(this.paymentForm.get('cashAmount')?.value || 0);
    const card = this.getActualAmountFromInp(this.paymentForm.get('creditCardAmount')?.value || 0);

    if (checked) {
      this.refundAsCashCardAmount = card;
      this.paymentForm.patchValue({
        cashAmount: this.customCurrency.transform((cash + card).toString()),
        creditCardAmount: this.customCurrency.transform("0")
      });
    } else {
      const restoredCard = this.refundAsCashCardAmount;
      this.refundAsCashCardAmount = 0;
      this.paymentForm.patchValue({
        cashAmount: this.customCurrency.transform(Math.max(0, cash - restoredCard).toString()),
        creditCardAmount: this.customCurrency.transform(restoredCard.toString())
      });
    }

    this.calculateBalance();
  }

  private setControlState(control: string, enable: boolean) {
    const ctrl = this.paymentForm.get(control);
    enable ? ctrl?.enable() : ctrl?.disable();
  }

  getCustomerInfo(customerId, isSelectedCustomer = true) {
    this.posSalesService.getCustomerDetailsById(customerId)
      .pipe().subscribe(details => {
        this.CustomerInfo(details, isSelectedCustomer);
      })
  }

  getPosSettings() {
    this.posSettingsService.getPosSettings()
      .pipe(take(1))
      .subscribe(res => {
        if (res) {
          this.travelerCheckTerm = res.OtherSettings.TravelerCheckTerm;
          this.isCashRoundingEnabled = res.OtherSettings.IsPOSCashRounding;
          this.makeTravelerNoOptional = res.OtherSettings.MakeTravelerNoOptional;
          //this.chgPayModeInVoid = res.OtherSettings.ChgPayModeInVoid; // TODO : implement this setting in future
          this.chgPayModeInVoid = false;
          if (!this.travelerCheckTerm) { this.travelerCheckTerm = "Traveler's" }
        }
        this.getSalesTaxAndCommissionSettings();
      });
  }

  getSalesTaxAndCommissionSettings() {
    this.posSettingsService.getSalesTaxAndCommission()
      .pipe(take(1))
      .subscribe(res => {
        if (res) {
          this.secondLevelTaxName = res.TaxSettings.PossecondLevelTaxName ? res.TaxSettings.PossecondLevelTaxName : "Sec Level Tax";
          this.applySalesTaxItemWise = res.TaxSettings.ApplyPostaxItemwise;
          this.enableOtherChargeinPos = res.POSSales.EnableOtherChargeinPos;
          this.posotherChargeName = res.POSSales.PosotherChargeName ?? "Other Charges";
          if (!this.applySalesTaxItemWise) {
            const totalNetPrice =
              this.getActualAmountFromInp(this.netPrice) +
              this.getActualAmountFromInp(this.salesTax) +
              this.getActualAmountFromInp(this.secondLvlTax);

            this.netPrice = this.customCurrency.transform(totalNetPrice.toString());
          }

          var totalAmountPaid = 0;
          var balance = this.netPrice;
          if (this.saleType == '5' && this.paymentData.InvoiceNo && !this.paymentData.IsPendingSale) {
            var prevPayCCCharge = this.paymentData.CustomerCccharge;
            totalAmountPaid = this.paymentData?.LayawayData?.LayawayInvoiceDetails?.TotalAmountPaid ?? 0;
            this.netPrice = this.customCurrency.transform((this.getActualAmountFromInp(this.netPrice) + prevPayCCCharge).toFixed(2));
            balance = this.customCurrency.transform((this.getActualAmountFromInp(this.netPrice) - totalAmountPaid).toString());
          }
          else if (this.saleType == '5' && (!this.paymentData.InvoiceNo || this.paymentData.IsPendingSale)) {
            balance = this.customCurrency.transform(this.paymentData?.LayawayData?.DownPayAmount ?? 0);
          }

          this.paymentForm.patchValue({
            balanceDue: balance,
            totalInvoiceAmount: this.netPrice
          })

          if (this.saleType == '8' || this.saleType == '7') {
            this.getInvoicePaymentDetails();
          }

          if (this.paymentData.IsPendingSale && this.getActualAmountFromInp(this.paymentData.OtherCharge ?? 0)) {
            this.paymentForm.get('otherCharges').setValue(this.paymentData.OtherCharge);
          }
        }
        var othChgFromSalePage = this.getActualAmountFromInp(this.paymentData.OtherCharge ?? 0);
        if (othChgFromSalePage != 0) {
          this.paymentForm.get('otherCharges').setValue(this.customCurrency.transform(othChgFromSalePage.toString()))
          this.calculateBalance();
        }
      });
  }

  validateEnteredGCNo() {
    var form = this.paymentForm;
    var record = this.giftCertificateList.find(e => e.GiftCertificateNo == form.get('appliedGCNo').value);
    if (record) {
      form.patchValue({
        appliedGCAmount: record.Balance
      });
      this.selectedGCExpiryDate = record.ExpiryDate ?? '';
    } else {
      this.showWarning(`Please enter a valid Gift Certificate #`);
      form.patchValue({
        appliedGCAmount: this.customCurrency.transform("0"),
        appliedGCNo: ""
      });
      this.selectedGCExpiryDate = '';
    }
  }

  filterGiftCertificates() {
    const field = this.gcSearchField;
    const value = (this.gcSearchValue || '').toLowerCase().trim();
    if (!value) {
      this.filteredGiftCertificateList = [...this.giftCertificateList];
    } else {
      this.filteredGiftCertificateList = this.giftCertificateList.filter(item =>
        (item[field] ?? '').toString().toLowerCase().includes(value)
      );
    }
  }

  giftCertificateSelected(val) {
    var form = this.paymentForm;
    var gcData = val.data;
    form.patchValue({
      appliedGCNo: gcData.GiftCertificateNo,
      appliedGCAmount: gcData.Balance
    });
    this.selectedGCExpiryDate = gcData.ExpiryDate ?? '';
    this.closeModalById("modalGiftCertificate");
  }

  calculateConvenienceFee() {
    if (this.chargeCCProcessingFee) {
      var convenienceFee = 0;
      var card = this.getActualAmountFromInp(this.inputtedCCAmt || 0);
      this.baseCardFees = this.getActualAmountFromInp(this.paymentForm.get('creditCardFees').value || 0);
      // if (this.baseCardFees > 0 && this.cardAmountFieldUpdate) {
      //   card = parseFloat((card - this.baseCardFees).toFixed(2));
      // }
      const cardIdSelected = this.paymentForm.get('creditCards').value;
      var creditcardData = this.creditCardList.filter(e => e.CreditCardTypeId == cardIdSelected);
      if (creditcardData) {
        if (card > 0) {
          if (creditcardData[0].ChargeType.includes("Percentage")) {
            var convenienceFee = parseFloat((card * ((creditcardData[0].Charge) / 100)).toFixed(2));
          }
          else {
            convenienceFee = creditcardData[0].Charge ?? 0;
          }
        }
      }
      convenienceFee = parseFloat(convenienceFee.toFixed(2))
      this.paymentForm.get('creditCardFees').setValue(this.customCurrency.transform(convenienceFee.toString()));
    }
    this.calculateBalance();
  }

  addConveninceFee() {
    this.cardAmountFieldUpdate = true;
    this.paymentForm.patchValue({
      totalPayment: this.totalPayment,
      creditCardAmount: this.customCurrency.transform(this.creditCardAmount.toString())
    }, { emitEvent: false });
  }

  calculateBalance(): void {
    // Cash rounding turns on as soon as cash is part of the tender, even when mixed with
    // other payment modes (cheque/card/traveler check/gift certificate). Turning it back OFF
    // is deliberately left to deactivateCashRounding() (cash field blur) - doing it here too
    // would race with activateCashRounding() (cash field focus), which sets isCashModeActive
    // true before the user has typed anything, so cash still reads 0 at that instant.
    if (this.isCashRoundingEnabled && this.saleType !== '7') {
      const cashEntered = this.getActualAmountFromInp(this.paymentForm.get('cashAmount').value || 0);
      if (cashEntered > 0) {
        this.isCashModeActive = true;
      }
    }

    this.paymentForm.get('chequeNo').disable();
    this.paymentForm.get('traverlerCheckNo').disable();
    this.paymentForm.get('creditCards').disable();
    this.paymentForm.get('keyedInTransaction').disable();
    const layawayDownPayment = this.getActualAmountFromInp(this.paymentData?.LayawayData?.DownPayAmount ?? 0);

    const gcNo = this.paymentForm.get('appliedGCNo').value;
    const cash = this.getActualAmountFromInp(this.paymentForm.get('cashAmount').value || 0);
    const cheque = this.getActualAmountFromInp(this.paymentForm.get('chequeAmount').value || 0);
    if(this.saleType == '7' || this.saleType == '8'){
      this.inputtedCCAmt = this.getActualAmountFromInp(this.paymentForm.get('creditCardAmount').value || 0);
    }
    var card = this.getActualAmountFromInp(this.inputtedCCAmt || 0);

    const otherCharge = this.getActualAmountFromInp(this.paymentForm.get('otherCharges').value || 0);
    const travelerCheckAmt = this.getActualAmountFromInp(this.paymentForm.get('travelerCheckAmt').value || 0);
    const gcBalance = this.getActualAmountFromInp(this.paymentForm.get('appliedGCAmount').value || 0);
    var cardfees = this.getActualAmountFromInp(this.paymentForm.get('creditCardFees').value || 0);
    if (card <= 0) {
      this.paymentForm.get('creditCardFees').setValue('$0.00');
      cardfees = 0;
      this.cardfessAddedToCardAmt = false;
    }

    let netPrice = 0;

    if (this.saleType == '8' || this.saleType == '7') {
      netPrice = this.getActualAmountFromInp(this.netPrice) + cardfees;
    } else {
      netPrice = this.getActualAmountFromInp(this.netPrice) + cardfees + otherCharge;
    }

    // if (this.cardfessAddedToCardAmt && card > 0) {
    //   if (this.baseCardFees == 0) {
    //     this.baseCardFees = cardfees;
    //   }
    //   if (this.baseCardFees > 0) {
    //     card = this.creditCardAmount - this.baseCardFees;
    //   }
    // }
    card = card + cardfees;
    if (cardfees > 0)
      this.cardfessAddedToCardAmt = true;

    var totalInvoiceAmount = netPrice;
    
    if (this.saleType != '8' && this.saleType != '7') {
      if (cheque > 0)
        this.paymentForm.get('chequeNo').enable();
      else
        this.paymentForm.get('chequeNo').setValue('')
    }

    if (this.saleType != '8' && this.saleType != '7') {
      if (travelerCheckAmt > 0)
        this.paymentForm.get('traverlerCheckNo').enable();
      else
        this.paymentForm.get('traverlerCheckNo').setValue('')
    }   

    var balance = 0;
    var changeAmount = 0;

    const refundAsCash = !!this.paymentForm.get('refundAsCash')?.value;
    const treatCardAsCash = (this.saleType === '7' || this.saleType === '8') && refundAsCash;
    const cashForRounding = treatCardAsCash ? Number((cash + card).toFixed(2)) : cash;
    const cardForNonCash = treatCardAsCash ? 0 : card;

    const nonCashTendered = cheque + cardForNonCash + travelerCheckAmt;

    let appliedGCAmount = 0;
    if (this.saleType !== '5') {
      const pendingBalForGC = Number((netPrice - nonCashTendered).toFixed(2));
      if (gcNo && gcBalance > 0 && pendingBalForGC > 0) {
        appliedGCAmount = Math.min(gcBalance, pendingBalForGC);
      }
    }
    const nonCashTenderedForRounding = Number((nonCashTendered + appliedGCAmount).toFixed(2));

    let requiredAmount = netPrice; // this is what customer must pay
    let effectiveCash = cashForRounding;

    if (this.saleType !== '7') {
      const resolved = this.resolveCashRounding(requiredAmount, nonCashTenderedForRounding, cashForRounding);
      requiredAmount = resolved.requiredAmount;
      effectiveCash = resolved.effectiveCash;
    }

    // Layaway WITHOUT invoice
    if (this.saleType == '5' && (!this.paymentData.InvoiceNo || this.paymentData.IsPendingSale)) {
      const resolved = this.resolveCashRounding(layawayDownPayment + cardfees, nonCashTendered, cashForRounding);
      requiredAmount = resolved.requiredAmount;
      effectiveCash = resolved.effectiveCash;
    }

    // Layaway WITH invoice
    if (this.saleType == '5' && this.paymentData.InvoiceNo && !this.paymentData.IsPendingSale) {
      const alreadyPaid = this.paymentData?.LayawayData?.LayawayInvoiceDetails?.TotalAmountPaid ?? 0;

      const layRequired = Number(
        (((this.getActualAmountFromInp(this.netPrice) + otherCharge)- alreadyPaid) + (cardfees ?? 0)).toFixed(2)
      );
      var paidInstCnt = this.paymentData?.LayawayData?.PaidInstallmentCount;
      const totalInstallments = this.paymentData?.LayawayData?.InstallmentDetails?.length ?? 0;

      if (paidInstCnt >= totalInstallments) {
        paidInstCnt = 0;
      }

      const isLastInstallment = paidInstCnt === totalInstallments - 1;

      // Apply rounding ONLY on last installment
      if (isLastInstallment) {
        const resolved = this.resolveCashRounding(layRequired, nonCashTendered, cashForRounding);
        requiredAmount = resolved.requiredAmount;
        effectiveCash = resolved.effectiveCash;
      } else {
        requiredAmount = layRequired;
        this.paymentForm.get('roundingDifference')?.setValue(this.customCurrency.transform("0"));
      }
    }

    this.effectiveCashAmount = effectiveCash;

    let nonCashPaid = cheque + cardForNonCash + travelerCheckAmt;

    if (this.saleType == '5') {
      const pendingBal = requiredAmount - nonCashPaid;
      if (gcNo && gcBalance > 0 && pendingBal > 0) {
        appliedGCAmount = Math.min(gcBalance, pendingBal);
      }
    }
    nonCashPaid += appliedGCAmount;

    this.giftCertificateAmount = appliedGCAmount;

    var totalPaid = effectiveCash + cheque + cardForNonCash + travelerCheckAmt;
    if (gcNo) {
      totalPaid += appliedGCAmount
    }

    if (nonCashPaid >= requiredAmount) {
      changeAmount = effectiveCash;
      balance = 0;
      if (this.saleType == '5') {
        balance = nonCashPaid - requiredAmount;
      }
    } else {
      const remaining = requiredAmount - nonCashPaid;
      if (effectiveCash > remaining) {
        changeAmount = effectiveCash - remaining;
        balance = 0;
      } else {
        changeAmount = 0;
        balance = remaining - effectiveCash; // Always positive if underpaid
      }
    }

    if (this.saleType != '5') {
      balance = requiredAmount - (totalPaid - changeAmount);
    }

    if (balance >= 0) {
      this.paymentForm.get('balanceDue').setValue(this.customCurrency.transform(balance.toString()), { emitEvent: false });
    } else {
      this.paymentForm.get('balanceDue').setValue(this.customCurrency.transform(balance.toString()), { emitEvent: false });
    }
    this.paymentForm.get('changeDue').setValue(this.customCurrency.transform(changeAmount.toString()), { emitEvent: false });

    const paymentSubTotal = totalPaid - changeAmount;
    this.totalPayment = this.customCurrency.transform(paymentSubTotal.toString());
    this.paymentForm.patchValue({
      totalPayment: this.customCurrency.transform(paymentSubTotal.toString()),
      totalInvoiceAmount: this.customCurrency.transform(totalInvoiceAmount.toString())
    }, { emitEvent: false });

    this.creditCardAmount = this.roundToTwo(card);
    if (card > 0 && this.saleType != '7' && this.saleType != '8') {
      this.paymentForm.get('creditCards').enable();
      if (this.transactionType == 'CREDITSALE') {
        this.paymentForm.get('keyedInTransaction').enable();
      }
      this.addConveninceFee();
    }
  }

  roundToTwo(num: number): number {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }

  checkPaymentType() {
    if (!this.IsStrip) {
      const cardTypeId = this.paymentForm.get('creditCards')?.value;
      const cardType = this.creditCardList.find(e => e.CreditCardTypeId == cardTypeId)?.CreditCardType;
      this.transactionType = cardType?.toLowerCase() === 'credit card' ? 'CREDITSALE' : 'DEBITSALE';
      if (this.transactionType == 'DEBITSALE') {
        this.paymentForm.get('keyedInTransaction').setValue(false);
        this.paymentForm.get('keyedInTransaction').disable();
      }
    } else {
      this.paymentForm.get('keyedInTransaction').setValue(false);
      this.paymentForm.get('keyedInTransaction').enable();
    }
    // recalc AND update displayed CC amount (so new fee reflects)
    this.calculateConvenienceFee();
  }

  onDenominationClick(amount: number) {
    let currentCash = this.getActualAmountFromInp(this.paymentForm.get('cashAmount').value || 0);
    if (currentCash >= this.getActualAmountFromInp(this.netPrice)) {
      return false;
    }
    currentCash += amount; // Add denomination value
    this.paymentForm.get('cashAmount').setValue(currentCash.toString());
    this.calculateBalance();
    this.formatField('cashAmount');
  }

  async formatField(controlName: string): Promise<void> {
    const rawValue = this.paymentForm.get(controlName).value;
    const parsedValue = Number(this.getActualAmountFromInp(rawValue) || 0);
    let value = isNaN(parsedValue) ? 0 : parsedValue;

    if (controlName === 'cashAmount' && this.isCashModeActive && this.isCashRoundingEnabled) {
      value = this.effectiveCashAmount;
    }

    this.paymentForm.get(controlName).setValue(this.customCurrency.transform(value.toString()), { emitEvent: false });
    if (controlName == "creditCardAmount" && value > 0) {
      await this.calculateConvenienceFee();
    }
  }

  getActualAmountFromInp(value: any): number {
    const numericValue = parseFloat(value.toString().replace(/[^0-9.-]/g, ''));
    return value.toString().includes('(') && value.toString().includes(')')
      ? -1 * numericValue
      : numericValue;
  }

  onCheckNumKeyPress(event: KeyboardEvent) {
    const allowedChars = /[a-zA-Z0-9]/;
    const key = event.key;
    if (event.key === 'Backspace' || event.key === 'Delete' || event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === '#') {
      return;
    }
    if (!key.match(allowedChars)) {
      event.preventDefault();
    }
  }

  setActiveControl(controlName: string) {
    this.activeControl = controlName;
  }

  tenderExactAmount() {
    if (this.activeControl) {
      this.paymentForm.get(this.activeControl)?.setValue(this.netPrice);
    }
  }

  onKeypadClick(value: string): void {
    if (!this.activeControl) return;

    const control = this.paymentForm.get(this.activeControl);
    if (!control) return;

    let currentValue = control.value || "";
    control.setValue(currentValue + value);
  }

  onClearKey(): void {
    if (!this.activeControl) return;

    const control = this.paymentForm.get(this.activeControl);
    if (!control) return;

    let currentValue = control.value || "";
    control.setValue(currentValue.slice(0, -1)); // remove last char
  }

  paymentResponse(response) {
    this.loaderIcon = Promise.resolve(true);
    if (response.PaymentSuccess) {
      this.processPayment = false;
      this.verifoneId = response.VerifoneId;
      const controls = this.paymentForm;
      const balanceDue = this.getActualAmountFromInp(controls.get('balanceDue').value);
      var layawayAccountStatus = false;
      if (this.saleType === '5') {
        if (balanceDue === 0 && this.paymentData?.InvoiceNo) {
          layawayAccountStatus = true;
        }
        this.paymentData.LayawayData.LayAccountStatus = layawayAccountStatus;
      }

      const { total } = this.getPaymentAmounts();
      const refundAsCash = !!controls.get('refundAsCash')?.value;
      let cashAmountValue = this.getActualAmountFromInp(controls.get('cashAmount').value)
        - this.getActualAmountFromInp(controls.get('roundingDifference').value);
      let cardAmountValue = this.getActualAmountFromInp(controls.get('creditCardAmount').value);
      if (refundAsCash) {
        cashAmountValue += cardAmountValue;
        cardAmountValue = 0;
      }
      let salesData = {
        InvoiceSeqNo: this.paymentData.InvoiceNo,
        CashAmount: cashAmountValue,
        ChequeAmount: this.getActualAmountFromInp(controls.get('chequeAmount').value),
        TravelerCheckAmount: this.getActualAmountFromInp(controls.get('travelerCheckAmt').value),
        CardAmount: cardAmountValue,
        BalanceDue: cashAmountValue,
        ChangeDue: this.getActualAmountFromInp(controls.get('changeDue').value),
        SalesTax: this.getActualAmountFromInp(controls.get('salesTax').value),
        SecondlvlTax: this.getActualAmountFromInp(controls.get('secondlvlTax').value),
        NetPrice: this.getActualAmountFromInp(this.netPrice),
        OtherCharges: this.getActualAmountFromInp(controls.get('otherCharges').value),
        AmountPaid: total,
        InvoiceAmount: this.getActualAmountFromInp(controls.get('totalInvoiceAmount').value),
        CheckNum: controls.get('chequeNo').value,
        CustomerId: this.customerId,
        SalesType: this.saleType,
        SalesmanId: this.paymentData.SalesmanId,
        ShippingId: this.paymentData.ShippingId,
        PaymentOrderId: response.OrderId,
        VerifoneId: response.VerifoneId,
        Reason: this.paymentData.Reason,
        CardType: controls.get('creditCards').value,
        CustomerCCCharge: this.getActualAmountFromInp(controls.get('creditCardFees').value),
        POSSalesItemDetails: [],
        TravelerCheckNum: controls.get('traverlerCheckNo').value,
        LayawaySalesDetails: this.paymentData.LayawayData,
        IsGiftCertificate: this.paymentData.SalesType == 'gc',
        GiftCertificateNumber: controls.get('appliedGCNo').value,
        GiftCertificateAmount: this.giftCertificateAmount,
        RoundingAmount: this.getActualAmountFromInp(controls.get('roundingDifference').value)
      }

      var salesList = this.paymentData.CustomerDetailsFromgrid;
      if (this.saleType == '7') {
        salesList = this.paymentData.CustomerDetailsFromgrid.filter(e => e.Selected);
      }
      for (const [idx, item] of salesList.entries()) {
        salesData.POSSalesItemDetails.push({
          SerialNumber: (this.saleType == '7' || this.saleType == '8') ? item.SerialNumber : idx + 1,
          BoothId: item.BoothId,
          VendorId: item.VendorSeqId ?? 2,
          StockId: item.StockId,
          ItemDescription: item.ItemDescription,
          Quantity: item.ItemQty,
          Rate: this.getActualAmountFromInp(item.ItemRate),
          DiscountPercent: item.ItemDiscValue,
          DiscountAmount: this.getActualAmountFromInp(item.ItemDiscAmount),
          DiscountedPrice: this.getActualAmountFromInp(item.ItemDiscountedPrice),
          SalesTax: this.getActualAmountFromInp(item.ItemSalesTax),
          SecondLevelTax: this.getActualAmountFromInp(item.ItemSecLvlTax),
          IsReturnItem: false,
          IsConsignItem: false,
          FlatCommissionRate: item.ItemCommission,
          InvoiceItemId: item.InvoiceItemId,
          GCStartDate: this.paymentData.SalesType == 'gc' ? new Date(item.GCStartDate) : new Date(),
          GCExpiryDate: this.paymentData.SalesType == 'gc' ? new Date(item.GCExpiryDate) : new Date(),
          GCMaxDays: this.paymentData.SalesType == 'gc' ? item.GCMaxDays : 0,
        })
      }

      this.posSalesService.savePosItemDetails(salesData)
        .pipe(take(1))
        .subscribe(res => {
          this.sharedData.clearPaymentDetails();
          this.ClosePaymentPage();
          const settings = this.paymentForm.value;

          if (!settings.displayReceipt && !settings.displayGC) {
            this.clearPaymentData.emit();
          }

          if (res.Success) {
            if (this.saleType == '8')
              this.toastr.success($localize`Invoice voided successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
            else if (this.saleType == '7')
              this.toastr.success($localize`Items returned successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
            else if (this.saleType == '5' && this.paymentData.InvoiceNo && !this.paymentData.IsPendingSale)
              this.toastr.success($localize`Layaway installment receipt is updated successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
            else
              this.toastr.success($localize`Transaction saved successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);

            this.loaderIcon = Promise.resolve(false);
            if (settings.displayReceipt || settings.printReceipt || settings.emailReceipt)
              this.printReceipt(res.Id, res.Message, settings.displayReceipt, settings.printReceipt, settings.emailReceipt, settings.displayGC, settings.printGC, res.ItemReturnId);

            if(settings.displayGC || settings.printGC){
              this.printOrDisplayGiftCertificate(res.Id, settings.displayGC, settings.printGC);
            }
          } else {
            if (this.verifoneId) {
              this.voidPayment = true;
            }
            if (this.saleType == '8') {
              this.toastr.error($localize`${res.Message}`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
            } else {
              this.toastr.error($localize`Error occured while saving transaction`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
            }
            this.loaderIcon = Promise.resolve(false);
          }
        }, err => {
          if (this.verifoneId) {
            this.voidPayment = true;
          }
          this.toastr.error($localize`Error occured while saving transaction`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
          this.loaderIcon = Promise.resolve(false);
        })
    }
    else {
      this.processPayment = false;
      this.voidPayment = false;
      this.loaderIcon = Promise.resolve(false);
    }
  }

  closeModalById(modalId: string) {
    const modalEl = document.getElementById(modalId);
    if (modalEl) {
      const modalInstance = window['bootstrap'].Modal.getInstance(modalEl);
      if (modalInstance) {
        modalInstance.hide();
      }
    }
    document.body.classList.remove('modal-open');

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    if (modalId == 'printReceiptPopup') {
      this.closeDisplay = true;
      this.routeBackToSalesPage()
    }

    if (modalId == 'printGCPopup') {
      this.closeGCDisplay = true;
      this.routeBackToSalesPage()
    }
  }

  printOrDisplayGiftCertificate(invoiceNo, display, print) {
    const params = {
      InvsNumber: invoiceNo,
      SalesReceiptid: 0
    };
    this.posSalesService.generateGCReceipt(params).pipe(take(1)).subscribe((res: any) => {
      if (!res.Success) return;
      const message = res.Message;
      this.loaderIcon = Promise.resolve(false);
      if (!message || !message.startsWith('data:application/pdf;base64,')) {
        Swal.fire('Error', `Invalid  PDF data in response`, 'error');
        this.clearPaymentData.emit();
        return;
      }

      // --- DISPLAY PDF IN MODAL ---
      if (display) {
        this.closeGCDisplay = false;
        this.showPDFModal(message, true);
      }

      // --- PRINT PDF ---
      if (print) {
        this.closeGCprint = false
        printJS({
          printable: message.split(',')[1],
          type: 'pdf',
          base64: true,
          onPrintDialogClose: () => {
            this.closeGCprint = true;
            this.routeBackToSalesPage();
          },
        });
      }
    });
  }

  printReceipt(invoiceNo, receiptId, display, print, email, displayGC = false, printGC = false, itemReturnId: number = null) {
    this.loaderIcon = Promise.resolve(true);

    var cardAmount = this.getActualAmountFromInp(this.paymentForm.get('creditCardAmount').value);
    const generateAndProcessPDF = (
      type: 'Receipt',
      display: boolean,
      print: boolean,
      email: boolean,
      baseTemplateId: number,
      emailSubject: string
    ) => {
      const params = {
        InvsNumber: invoiceNo,
        SalesReceiptid: receiptId ? receiptId : 0,
        LayawayPreview: false,
        ItemReturnId: itemReturnId
      };
      this.posSalesService.generatePOSReceipt(params).pipe(take(1)).subscribe((res: any) => {
        if (!res.Success) return;
        const message = res.Message;
        this.loaderIcon = Promise.resolve(false);
        if (!message || !message.startsWith('data:application/pdf;base64,')) {
          Swal.fire('Error', `Invalid ${type} PDF data in response`, 'error');
          this.clearPaymentData.emit();
          return;
        }

        // --- DISPLAY PDF IN MODAL ---
        if (display) {
          this.closeDisplay = false;
          this.showPDFModal(message);
        }

        // --- EMAIL PDF ---
        if (email) {
          this.closeEmail = false;
          this.sendEmail(
            0,
            5,
            message,
            `${this.getSaleTypeAttachmentPrefix()}_${type}`,
            emailSubject,
            invoiceNo,
            this.paymentForm.get('emailAddress').value
          );
        }

        // --- PRINT PDF ---
        if (print && !this.printThermalReceipt) {
          this.closePrint = false
          printJS({
            printable: message.split(',')[1],
            type: 'pdf',
            base64: true,
            onPrintDialogClose: () => {
              this.closePrint = true;
              this.routeBackToSalesPage();
            },
          });
        } else if (print && this.printThermalReceipt) {
          var customProtocolUrl;
          if (this.saleType == '5') {
            if (cardAmount > 0) {
              customProtocolUrl = 'silentprinter://?methodname=layawaypaymentreceipt&param1=' + invoiceNo + '&param2=' + this.thermalReceiptCopies + '&param3=' + receiptId + '&uniqueSessionId=' + this.uniqueSessionId + '&MerchantCopy=' + (this.posMerchantCopy ?? false) + '&CustomerCopy=' + (this.posCustomerCopy ?? false) + '&MerchantNoOfCopies=' + (this.posMerchantCopies ?? 0) + '&CustomerNoOfCopies=' + (this.posCustomerCopies ?? 0);
            } else {
              customProtocolUrl = 'silentprinter://?methodname=layawaypaymentreceipt&param1=' + invoiceNo + '&param2=' + this.thermalReceiptCopies + '&param3=' + receiptId + '&uniqueSessionId=' + this.uniqueSessionId;
            }
            window.location.href = customProtocolUrl;
          } else {
            const methodName =
              this.saleType === "7" ? "returnsalereceipt" :
                this.saleType === "8" ? "posvoidreceipt" :
                  "pospaymentreceipt";

            const param1 = invoiceNo ?? "";
            const param2 = this.thermalReceiptCopies ?? 1;
            const session = this.uniqueSessionId ?? "";
            const mCopy = this.posMerchantCopy ?? false;
            const cCopy = this.posCustomerCopy ?? false;
            const mNo = this.posMerchantCopies ?? 0;
            const cNo = this.posCustomerCopies ?? 0;
            const itemRetId = itemReturnId ?? 0;
            let params =
              `methodname=${methodName}&param1=${param1}&param2=${param2}&uniqueSessionId=${session}&itemReturnId=${itemRetId}`;

            if (cardAmount > 0) {
              params += `&MerchantCopy=${mCopy}&CustomerCopy=${cCopy}&MerchantNoOfCopies=${mNo}&CustomerNoOfCopies=${cNo}`;
            }

            // Final URL
            const customProtocolUrl = `silentprinter://?${params}`;
            window.location.href = customProtocolUrl;
          }
          
          if(!displayGC && !printGC){
          this.routeBackToSalesPage();
          }
        }
      }
      );
    };

    // Handle Receipt
    if (display || print || email) {
      generateAndProcessPDF(
        'Receipt',
        display,
        print,
        email,
        2,
        'Sales Receipt'
      );
    }
  }

  routeBackToSalesPage() {
    if (this.closeDisplay && this.closePrint && this.closeEmail && this.closeGCDisplay && this.closeGCprint) {
      this.clearPaymentData.emit();
    }
  }

  restoreScroll() {
    document.body.style.overflow = 'auto';
    document.documentElement.style.overflow = 'auto';
  }

  numberOnlyForCash(event: any) {
    // Get the current value of the input field
    const currentValue: string = event.target.value;
    const currentCursorPosition = event.target.selectionStart;
    const currentSelectionLength = event.target.selectionEnd - event.target.selectionStart;
    if (currentSelectionLength === currentValue.length) {
      return true;
    }
    // Check if the input value is "0" and if it contains a "$" sign
    if (currentValue === '0' && !currentValue.includes('$')) {
      // Set the new value with "$" sign
      event.target.value = '$0';
      // Set the cursor position after the "$" sign
      event.target.setSelectionRange(1, 1);
      return;
    }
    // Check if the "$" sign is present in the current value
    const hasDollarSign = currentValue.includes('$');
    // Allow input if the "$" sign is not present
    if (!hasDollarSign) {
      return;
    }
    // Get the cursor position
    const caretPosition = event.target.selectionStart;
    // Check if the cursor position is after the "$" sign
    const hasDollarSignBeforeCaret = currentValue.slice(0, caretPosition).includes('$');
    // If the cursor is not after the "$" sign, prevent input
    if (!hasDollarSignBeforeCaret) {
      event.preventDefault();
      return;
    }

    // Allow digits, a dot, and an optional '-' at the beginning
    const pattern = /^-?\d*\.?\d*$/;
    // Get the character entered by the user
    const inputChar = String.fromCharCode(event.charCode);
    // Check if the input matches the pattern
    if (!pattern.test(inputChar) || // If the entered character is not allowed
      (inputChar === '.' && currentValue.includes('.')) || // Or if the dot is already present
      (inputChar === '-' && currentValue.indexOf('-') !== -1)) { // Or if '-' is entered more than once
      event.preventDefault(); // Prevent the character from being entered
    }
  }

  private getSaleTypeAttachmentPrefix(): string {
    switch (this.saleType) {
      case '1':
        return 'RetailSale';
      case '2':
        return 'WholesaleSale';
      case '3':
        return 'OnlineSale';
      case '5':
        return 'LayawaySale';
      case '6':
        return 'PendingSale';
      case '7':
        return 'ReturnSale';
      case '8':
        return 'VoidSale';
      default:
        return 'Sale';
    }
  }

  private sendEmail(
    accountReceiptId: number,
    baseTemplateId: number,
    message: string,
    fileName: string,
    subject: string,
    invoiceNo: number,
    CustomerEmailAdd: string
  ) {
    const emailData = [{
      AccountReceiptID: accountReceiptId,
      VendorID: 0,
      BaseTemplateID: baseTemplateId,
      AttachmentFile: message,
      AttachmentFileName: fileName,
      FileType: "application/pdf",
      Subject: subject,
      InvoiceNo: invoiceNo,
      POSCustomerEmail: CustomerEmailAdd
    }];

    this.generalService.composeEmails(emailData).subscribe(() => {
      console.log(`${subject} email sent successfully`);
      this.closeEmail = true;
    }, err => {
      this.closeEmail = true;
    });
  }

  private showPDFModal(base64Data: string, gcReceipt: boolean = false) {
    this.loading = true;
    const modalId = gcReceipt ? 'printGCPopup' : 'printReceiptPopup';
    const pdfVar = gcReceipt ? 'gcreceiptUrl' : 'receiptUrl';

    const modalEl = document.getElementById(modalId);
    if (modalEl) {
      let modalInstance = window['bootstrap'].Modal.getInstance(modalEl);
      if (!modalInstance) {
        modalInstance = new window['bootstrap'].Modal(modalEl, {
          backdrop: 'static',
          keyboard: false
        });
      }
      modalInstance.show();
    }

    const pdfBase64 = base64Data.split(',')[1];
    const blob = this.base64ToBlob(pdfBase64, 'application/pdf');
    this[pdfVar] = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
    this.loading = false;
  }

  private base64ToBlob(base64: string, type: string): Blob {
    const byteCharacters = atob(base64);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    return new Blob([byteArray], { type });
  }

  CustomerInfo(data, isSelectedCustomer = true) {
    this.customerId = data.CustomerId;
    this.existingCustomer = isSelectedCustomer;
    this.posSalesService.getCustomerDetailsById(this.customerId)
      .pipe().subscribe(details => {
        this.customerData = details;
      });
  }

  cancelPaymentPage() {
    this.closePaymentPage.emit({ cancelled: true, otherCharge: this.paymentForm.get('otherCharges').value });
  }

  closeCustomerInfoModal(val) {
    this.closeModalById('customerModal');
  }
  
  openCustomerForm(formReq) {
    this.customerSearch = formReq == "search" ? true : false;
    this.newCustomer = formReq == "new" ? true : false;
  }

  closeModal(modal) {
    if (modal.classList.contains('show')) {
      $(modal).modal('hide');
      setTimeout(() => {
        modal.style.display = 'none';
        modal.classList.remove('show');
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
        document.body.classList.remove('modal-open');
      }, 300);
    }
  }

  getCCCredentials() {
    this.paymentService.getCCCredentials().subscribe((res) => {
      if (res !== null) {
        this.paymentGatewayCredentials = res.GatewayDetails ? JSON.parse(res.GatewayDetails) : null;
        this.processCreditCardOnline = res.ProcessCreditCardOnline;
        //added below code for switching Payment gate way
        if (res.PaymentGateWay == EPaymentGateway.Stripe) {
          this.IsStrip = true;
        } else if (res.PaymentGateWay == EPaymentGateway.OpenEdgeExpress) {
          this.IsOpenEdgeExpress = true;
        }
      }
    })
  }

  private getPaymentAmounts() {
    const controls = this.paymentForm;

    const cash = parseFloat(this.getActualAmountFromInp(controls.get('cashAmount').value).toFixed(2));
    const cheque = parseFloat(this.getActualAmountFromInp(controls.get('chequeAmount').value).toFixed(2));
    const travelerCheck = parseFloat(this.getActualAmountFromInp(controls.get('travelerCheckAmt').value).toFixed(2));
    const card = parseFloat(this.getActualAmountFromInp(controls.get('creditCardAmount').value).toFixed(2));
    const gcAmount = parseFloat(this.giftCertificateAmount.toFixed(2));
    let roundingAmount = 0;
    if (this.isCashModeActive && this.isCashRoundingEnabled) {
      roundingAmount = parseFloat(this.getActualAmountFromInp(controls.get('roundingDifference').value).toFixed(2));
    }

    const total = parseFloat((cash + cheque + card + travelerCheck + gcAmount - roundingAmount).toFixed(2));

    return { cash, cheque, card, travelerCheck, total };
  }

  private showWarning(message: string, focusElement?: any) {
    Swal.fire({
      title: $localize`Warning`,
      text: message,
      icon: "warning",
      confirmButtonText: $localize`Ok`,
    }).then(result => {
      if (result.value && focusElement) {
        focusElement.nativeElement.focus();
      }
    });
  }

  private validateAndProcessPayment(total: number, expected: number, context: 'return' | 'void') {

    if (total !== expected) {
      const msg =
        context === 'return'
          ? $localize`Please enter the correct refund amount in payment options.`
          : $localize`Void payment amount should be same as invoice amount`;
      this.showWarning(msg);
      return false;
    }

    const { cash, cheque, card, travelerCheck } = this.getPaymentAmounts();
    const controls = this.paymentForm;
    const cardAmount = this.getActualAmountFromInp(controls.get('creditCardAmount').value);
    const refundAsCash = !!controls.get('refundAsCash')?.value;

    if (cheque > 0 && !this.paymentForm.get('chequeNo').value) {
      this.showWarning($localize`Please enter the check#.`, this.chequeNo);
      return;
    }

    if (cardAmount > 0 && cardAmount !== this.ccAmountPaid) {
      if (this.saleType == '8') {
        this.showWarning(`CC Void payment amount should be same as paid amount`);
        return false;
      }
    }

    if (cardAmount > 0 && this.paymentGatewayCredentials && this.processCreditCardOnline && !refundAsCash) {
      this.voidPayment = true;
      if (this.saleType == '7') {
        this.forceCreditReturn = true;
      }
      return;
    }

    const response = { PaymentSuccess: true, OrderId: '', VerifoneId: 0 };
    this.paymentResponse(response);
    return true;
  }

  saveReturnSales() {
    const { total } = this.getPaymentAmounts();
    let returnAmount = this.getActualAmountFromInp(this.returnAmount);
    //let roundingOffAmount = this.getActualAmountFromInp(this.paymentForm.get('roundingDifference').value);
    // apply rounding if enabled
    // if (this.isCashRoundingEnabled && this.isCashModeActive) {
    //   returnAmount = returnAmount - roundingOffAmount;
    // }
    return this.validateAndProcessPayment(total, returnAmount, 'return');
  }

  saveVoidSales() {
    const { total } = this.getPaymentAmounts();
    let totalInvoiceAmount = this.getActualAmountFromInp(this.paymentForm.get('totalInvoiceAmount').value);
    // apply rounding if enabled
    // if (this.isCashRoundingEnabled && this.isCashModeActive) {
    //   totalInvoiceAmount = this.roundToNearestNickel(totalInvoiceAmount);
    // }
    this.closeModalById('voidOnlineCCConfirmModal');
    return this.validateAndProcessPayment(total, totalInvoiceAmount, 'void');
  }

  saveSalesPayment() {
    if (this.paymentForm.get('emailReceipt').value && !this.paymentForm.get('emailAddress').value) {
      this.showWarning($localize`Please enter customer email address`);
      return;
    }

    if (
      this.paymentForm.get('emailReceipt')?.value &&
      this.paymentForm.get('emailAddress')?.invalid
    ) {
      this.paymentForm.get('emailAddress')?.markAsTouched();
      this.showWarning($localize`Please enter a valid customer email address`);
      return;
    }

    if (this.saleType === '8') {
      const refundAsCash = !!this.paymentForm.get('refundAsCash')?.value;
      if (this.paymentGatewayCredentials && this.processCreditCardOnline && this.getActualAmountFromInp(this.paymentForm.get('creditCardAmount').value) > 0 && !refundAsCash) {
        this.openModalById('voidOnlineCCConfirmModal');
        return;
      }
      if (!this.saveVoidSales()) return;
    }
    else if (this.saleType === '7') {
      if (!this.saveReturnSales()) return;
    } else {
      const { cash, cheque, card, travelerCheck, total } = this.getPaymentAmounts();

      var salesList = this.paymentData.CustomerDetailsFromgrid;
      const totalItemRate = salesList.reduce((sum, item) => {
        const rate = this.getActualAmountFromInp(item.ItemRate);
        const qty = item.ItemQty || 1;
        return sum + (rate * qty);
      }, 0);

      const totalDiscount = salesList.reduce((sum, item) => {
        return sum + this.getActualAmountFromInp(item.ItemDiscAmount);
      }, 0);

      var fullDiscApplied = false;
      if (totalItemRate == totalDiscount) fullDiscApplied = true;

      if (total === 0 && !fullDiscApplied) {
        this.showWarning($localize`Please enter the cash/card or check amount!`);
        return;
      }

      if (this.saleType != '5') {
        // const totalInvoiceAmount = this.getActualAmountFromInp(this.paymentForm.get('totalInvoiceAmount').value);
        // const changeAmount = this.getActualAmountFromInp(this.paymentForm.get('changeDue').value ?? 0);
        // const roundedAmount = this.getActualAmountFromInp(
        //   this.paymentForm.get('roundingDifference')?.value ?? 0
        // );
        // if ((total - changeAmount - roundedAmount) !== totalInvoiceAmount) {
        //   this.showWarning($localize`Please make payment(exact amount) and then try to save`);
        //   return false;
        // }
        const balanceDue = this.getActualAmountFromInp(
          this.paymentForm.get('balanceDue')?.value ?? 0
        );

        if (balanceDue !== 0) {
          this.showWarning($localize`Please make payment (exact amount) and then try to save`);
          return false;
        }
      }
      else if (this.saleType == '5' && (!this.paymentData.InvoiceNo || this.paymentData.IsPendingSale)) {
        const balanceDue = this.getActualAmountFromInp(this.paymentForm.get('balanceDue').value);

        if (balanceDue != 0) {
          this.showWarning($localize`Please ensure balance due is 0`);
          return false;
        }
      }

      if (cheque > 0 && !this.paymentForm.get('chequeNo').value) {
        this.showWarning($localize`Please enter the check#.`, this.chequeNo);
        return;
      }

      if (travelerCheck > 0 && !this.makeTravelerNoOptional && !this.paymentForm.value['traverlerCheckNo']) {
        this.showWarning($localize`Please enter the Traverler's Check#.`, this.chequeNo);
        return;
      }

      if (card > 0 && !this.transactionType) {
        this.showWarning($localize`Please select the card type.`);
        return;
      }

      const gcNo = this.paymentForm.get('appliedGCNo').value;
      const gcAmount = this.getActualAmountFromInp(this.paymentForm.get('appliedGCAmount').value);
      if (gcNo && gcAmount > 0) {
        var balanceAmount = this.getActualAmountFromInp(this.giftCertificateList.find(e => e.GiftCertificateNo == gcNo)?.Balance ?? 0);
        if (gcAmount > balanceAmount) {
          this.showWarning($localize`Payment Amount Exceeds Gift Certificate Amount. Please enter a valid amount`);
          return;
        }
      }

      this.proceedWithPayment();
    }
  }

  openModalById(modalId) {
    document.querySelectorAll('.modal-backdrop').forEach(e => e.remove());
    const modal = new bootstrap.Modal(
      document.getElementById(modalId)!,
      {
        backdrop: 'static',
        keyboard: false,
        focus: true
      }
    );
    modal.show();
  }

  proceedWithPayment() {
    const controls = this.paymentForm;
    const cardAmount = this.getActualAmountFromInp(controls.get('creditCardAmount').value);

    // Default response object
    const response = {
      PaymentSuccess: true,
      OrderId: "",
      VerifoneId: 0
    };

    if (cardAmount > 0 && this.paymentGatewayCredentials && this.processCreditCardOnline) {
      this.processPayment = true;
    } else {
      this.paymentResponse(response);
    }
  }

  getAllCreditCardsByMarket() {
    this.loaderIcon = Promise.resolve(true);
    this.creditCardTypeService.GetAllCreditCardsByMarket()
      .pipe(take(1)).subscribe((res: any) => {
        this.creditCardList = res.filter(el => !el.IsInactive).map((el, i) => ({
          CreditCardTypeId: el.CreditCardTypeId,
          CreditCardTypeDesc: el.CompanyCreditCardTypeDesc,
          ChargeType: el.ChargeType,
          Charge: el.Charge,
          CreditCardType: el.CardType,
          MarketId: el.MarketId
        }));
        this.allCreditCards = this.creditCardList;
        this.paymentForm.get('creditCards').setValue(this.creditCardList[0]?.CreditCardTypeId);
        this.loaderIcon = Promise.resolve(false);
      }, err => {
        this.loaderIcon = Promise.resolve(false);
      });
  }

    voidPaymentResponse(response) {
        this.voidPayment = false;
        if (response.PaymentSuccess) {
            if (this.saleType == '8' || this.saleType == '7') {
                const response = {
                    PaymentSuccess: true,
                    OrderId: this.orderId,
                    VerifoneId: this.verifoneId
                };
                this.paymentResponse(response);
            }
        }
        else {
            this.processPayment = false;
            this.voidPayment = false;
            this.loaderIcon = Promise.resolve(false);
        }
    }

  private roundToNearestNickel(amount: number): number {
    const cents = Math.round(amount * 100);
    const remainder = cents % 5;
    let roundedCents = cents;
    if (remainder !== 0) {
      if (remainder <= 2) {
        roundedCents = cents - remainder; // round down
      } else {
        roundedCents = cents + (5 - remainder); // round up
      }
    }

    return Number((roundedCents / 100).toFixed(2));
  }

  // nonCashAmount is the portion of `amount` already covered by exact, non-cash tenders
  // (cheque/card/traveler check) - only the remaining cash portion gets rounded to the
  // nearest nickel. Used for pre-filling the cash field itself (F2) - unconditional, since
  // the caller is deciding what value to put IN the field, not reacting to what's there.
  private applyCashRoundingIfEnabled(amount: number, nonCashAmount: number = 0): number {
    if (!this.isCashModeActive || !this.isCashRoundingEnabled) {
      this.paymentForm.get('roundingDifference')?.setValue(this.customCurrency.transform("0"));
      return Number(amount.toFixed(2));
    }

    const cashPortion = Number((amount - nonCashAmount).toFixed(2));
    const roundedCashPortion = Number(this.roundToNearestNickel(cashPortion).toFixed(2));
    const diff = Number((roundedCashPortion - cashPortion).toFixed(2));
    this.paymentForm.get('roundingDifference')?.setValue(this.customCurrency.transform(diff.toFixed(2).toString()));
    return Number((nonCashAmount + roundedCashPortion).toFixed(2));
  }

  private resolveCashRounding(amount: number, nonCashAmount: number, cash: number): { requiredAmount: number, effectiveCash: number } {
    if (!this.isCashModeActive || !this.isCashRoundingEnabled) {
      this.paymentForm.get('roundingDifference')?.setValue(this.customCurrency.transform("0"));
      return { requiredAmount: Number(amount.toFixed(2)), effectiveCash: cash };
    }

    const cashPortionOwed = Number((amount - nonCashAmount).toFixed(2));

    if (cashPortionOwed <= 0) {
      this.paymentForm.get('roundingDifference')?.setValue(this.customCurrency.transform("0"));
      return { requiredAmount: Number(amount.toFixed(2)), effectiveCash: cash };
    }

    const roundedCashPortion = Number(this.roundToNearestNickel(cashPortionOwed).toFixed(2));

    const roundingFloor = Math.min(cashPortionOwed, roundedCashPortion);
    const roundingCeiling = Math.max(cashPortionOwed, roundedCashPortion);

    if (cash < roundingFloor) {
      this.paymentForm.get('roundingDifference')?.setValue(this.customCurrency.transform("0"));
      return { requiredAmount: Number(amount.toFixed(2)), effectiveCash: cash };
    }

    const diff = Number((roundedCashPortion - cashPortionOwed).toFixed(2));
    this.paymentForm.get('roundingDifference')?.setValue(this.customCurrency.transform(diff.toFixed(2).toString()));

    const effectiveCash = cash > roundingCeiling ? cash : roundedCashPortion;

    return {
      requiredAmount: Number((nonCashAmount + roundedCashPortion).toFixed(2)),
      effectiveCash
    };
  }

  activateCashRounding() {

    if (!this.isCashRoundingEnabled) return;
    // Do NOt round if any non-cash payment exists
    if (this.hasNonCashPayment()) {
      return;
    }

    if (this.isCashModeActive) return;
    this.isCashModeActive = true;

    
    this.calculateBalance();
  }

  deactivateCashRounding() {
    if (!this.isCashModeActive) return;
    this.isCashModeActive = false;
    this.paymentForm.get('roundingDifference')?.setValue(this.customCurrency.transform("0"));
    this.calculateBalance();
  }

  private hasNonCashPayment(): boolean {
    if (!this.isCashRoundingEnabled) return;

    const cheque = this.getActualAmountFromInp(this.paymentForm.get('chequeAmount').value || 0);
    const card = this.getActualAmountFromInp(this.paymentForm.get('creditCardAmount').value || 0);
    const traveler = this.getActualAmountFromInp(this.paymentForm.get('travelerCheckAmt').value || 0);
    const giftCard = this.getActualAmountFromInp(this.paymentForm.get('appliedGCAmount').value || 0);

    return cheque > 0 || card > 0 || traveler > 0 || giftCard > 0;
  }

  ClosePaymentPage() {
    this.processPayment = false;
    this.voidPayment = false;
  }

  ngOnDestroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
}
